import React from "react";
import Links from "./Links";
import {
  MenuPromosProviderContextValue,
  useMenuPromos
} from "../../MenuPromosProvider";

const PromoLinks: React.FC = () => {
  const activePromos = useMenuPromos();
  const links = (activePromos.map(toPromoLink) || []).sort((a, b) =>
    a.label.localeCompare(b.label)
  );

  return <Links links={links} />;
};

export const toPromoLink = (promo: MenuPromosProviderContextValue[number]) => {
  const svgIcon = promo.iconVertical?.asset?.url;
  const normalIcon = promo.cardWithIcon?.icon;

  return {
    _key: promo._id!,
    href: promo.fullPath!,
    label: promo.title?.localized || "",
    content: promo.fycFilterDescription?.localized || "",
    trackingName: promo.metadata?.tracking?.name,
    image: svgIcon
      ? { _type: "svg" as const, url: svgIcon }
      : normalIcon
        ? { _type: "package-icon" as const, name: normalIcon }
        : undefined
  };
};

export default PromoLinks;
